export default "__VITE_ASSET__gaJJbxAO__"